module.exports = __webpack_public_path__ + "a97a64e1ff866f4034ea50db2d9e50bc.svg";